import { Toaster } from 'react-hot-toast';

export const ToastNotification = () => {
  return (
    <Toaster
      position="top-left"
      toastOptions={{
        duration: 5000,
        className: 'text-lg !bg-blue-100',
        error: {
          className: '!bg-rose-200',
        },
        success: {
          className: '!bg-green-100',
        },
      }}
    />
  );
};
